export const translations = {
  fr: {
    nav: {
      solution: "Solution",
      casReels: "Cas reels",
      engagements: "Engagements",
      dashboard: "Dashboard",
      connexion: "Connexion",
      contact: "Contact",
    },
    footer: {
      tagline: "Anti-gaspillage \u00b7 Securite alimentaire \u00b7 Transparence",
    },
    home: {
      heroTag1: "Plug & play", heroTag2: "Zero friction", heroTag3: "Activation de donnees", heroTag4: "Nouveaux revenus",
      h1_1: "Activez vos donnees dormantes.", h1_2: "Creez de la valeur.", h1_3: "Sans friction.",
      heroP: "KYRA transforme les donnees deja presentes dans vos systemes \u2014 DLC, rappels produits, historiques d'achat \u2014 en leviers de performance economique, de securite alimentaire et de reduction du gaspillage.",
      heroPills: ["Plug & play", "Zero friction utilisateur", "Pas de complexite operationnelle", "Activation de donnees existantes"],
      ctaContact: "Demander une demo",
      ctaSolution: "Decouvrir la solution",
      heroKpi1V: "0", heroKpi1L: "friction ajoutee", heroKpi2V: "100%", heroKpi2L: "donnees existantes", heroKpi3V: "2h", heroKpi3L: "delai alerte rappel", heroKpi4V: "J-2", heroKpi4L: "notification DLC",

      probLabel: "Le probleme",
      probTitle: "Les donnees existent. Elles ne sont pas activees.",
      probSub: "Les distributeurs et les marques font face a des pressions simultanees : conformite reglementaire, rappels produits, risque sanitaire, risque reputationnel, objectifs anti-gaspillage 2030. Les donnees pour y repondre sont la. Mais elles restent cloisonnees, non exploitees en temps reel, deconnectees des decisions business.",
      probCards: [
        { title: "Pression reglementaire", desc: "Obligations croissantes sur la securite alimentaire et les rappels. Jusqu'a 75 000 EUR d'amende par infraction." },
        { title: "Exposition aux rappels", desc: "Produits rappeles deja chez les consommateurs. Aucun lien direct entre le produit et le foyer expose." },
        { title: "Risque reputationnel", desc: "Chaque crise mal geree detruit la confiance. Kinder, Lactalis, Buitoni : les precedents sont clairs." },
        { title: "Gaspillage alimentaire", desc: "131 kg gaspilles par personne par an en Europe. Les menages representent 53% des pertes." }
      ],
      probInsight: "Le vrai probleme n'est pas l'absence de donnees. C'est qu'elles sont mal exploitees, cloisonnees en silos, et pas activees en temps reel.",
      probRegTitle: "Deplacez le risque reglementaire.",
      probRegText: "KYRA deplace le point de friction reglementaire vers un agent externe. Cela reduit directement l'exposition operationnelle et juridique du distributeur.",

      solLabel: "La solution KYRA",
      solTitle: "Activez ce qui existe. Sans rien ajouter.",
      solSub: "KYRA active des donnees deja presentes mais non exploitees. DLC, rappels, historiques d'achat : tout est transforme en decisions exploitables, sans complexite operationnelle supplementaire.",
      solPills: ["Plug & play", "Integration dans l'existant", "Zero friction", "Pas de complexite ajoutee"],
      solF1T: "Active les DLC et les rappels", solF1D: "Exploitation en temps reel des dates limites de consommation et des rappels produits officiels.",
      solF2T: "Reduit les pertes", solF2D: "Optimisation des stocks et reduction de la destruction produit grace a l'activation des donnees.",
      solF3T: "Securise la chaine alimentaire", solF3D: "Gestion proactive des rappels avec notification directe aux consommateurs concernes.",
      solF4T: "Genere de nouveaux revenus", solF4D: "Transformation d'actifs dormants en leviers de performance economique pour retailers et marques.",
      solRegTitle: "Couche d'orchestration reglementaire",
      solRegText: "KYRA agit comme une couche tampon entre le distributeur et les obligations de conformite. Le risque reglementaire est deplace vers un agent externe, reduisant fortement l'exposition du retailer.",
      solNoComplex: "KYRA n'ajoute pas de complexite operationnelle : elle active ce qui existe deja, mais qui n'est ni exploite en temps reel, ni integre dans les decisions business.",

      fsLabel: "Securite alimentaire",
      fsTitle: "Protegez vos clients. Protegez votre marque.",
      fsSub: "KYRA transforme la gestion des rappels produits d'un risque subi en un avantage competitif maitrise.",
      fsItems: [
        { title: "Gestion proactive des rappels", desc: "Detection automatique, croisement avec les achats, notification immediate aux consommateurs concernes." },
        { title: "Reduction des risques sanitaires", desc: "Plus aucun consommateur ignore qu'un produit dans son frigo a ete rappele." },
        { title: "Protection de l'image de marque", desc: "Reagir en 2 heures au lieu de 2 semaines. Maitrise totale de la communication de crise." },
        { title: "Conformite garantie", desc: "Rapport de conformite DGCCRF genere automatiquement. Preuve d'envoi horodatee et tracable." }
      ],
      fsKpi1V: "3 200+", fsKpi1L: "rappels/an en France", fsKpi2V: "< 2h", fsKpi2L: "delai d'alerte", fsKpi3V: "100%", fsKpi3L: "tracabilite",

      fwLabel: "Anti-gaspillage",
      fwTitle: "Transformez les pertes en valeur.",
      fwSub: "KYRA exploite les dates de consommation pour reduire les pertes, optimiser les stocks et contribuer aux objectifs zero gaspillage 2030.",
      fwItems: [
        { title: "Exploitation intelligente des DLC", desc: "Chaque produit achete est suivi. Les consommateurs sont prevenus avant que les produits expirent." },
        { title: "Reduction des pertes", desc: "Moins de produits jetes = meilleure marge. Optimisation directe du rendement stock." },
        { title: "Creation de valeur economique", desc: "Des actifs dormants transformes en leviers de revenus pour les retailers et les marques." },
        { title: "Objectif zero gaspillage 2030", desc: "Loi AGEC : -50% de gaspillage d'ici 2030. KYRA fournit l'outil pour y arriver." }
      ],
      fwKpi1V: "59 M", fwKpi1L: "tonnes de dechets/an en Europe", fwKpi2V: "131 kg", fwKpi2L: "gaspilles/personne/an", fwKpi3V: "-50%", fwKpi3L: "objectif 2030",

      ctaLabel: "Contact",
      ctaTitle: "Parlons-en.",
      ctaSub: "Vous etes enseigne, distributeur ou investisseur. Decouvrez comment KYRA active vos donnees dormantes.",
      ctaBtn1: "Demander une demo",
      ctaBtn2: "Voir la solution",
    },
    solutions: {
      kw1: "Securite alimentaire", kw2: "Anti-gaspillage", kw3: "Deux modules",
      h1_1: "La donnee que vous avez deja.", h1_2: "Activee pour vos clients.",
      sub: "KYRA se connecte aux systemes existants des distributeurs. Pas de refonte. Pas d'infrastructure lourde. Deux modules complementaires, un seul principe : la bonne information, au bon moment, a la bonne personne.",
      ctaDemo: "Demander une demonstration",
      archLabel: "Architecture", archTitle: "Comment KYRA fonctionne.",
      archSub: "Les donnees d'achat entrent. Les rappels et les DLC alimentent le moteur. Les alertes sortent \u2014 personnalisees, automatiques, tracables.",
      mod1Label: "Module 01", mod1Title: "Rappels produits.",
      mod1Sub2: "Zero consommateur laisse sans information.",
      mod1Sub: "3 200 rappels sont publies chaque annee en France. La plupart des consommateurs qui ont achete ces produits ne l'apprennent jamais. KYRA ferme cette breche.",
      mod1HowTag: "Comment ca fonctionne",
      mod1HowTitle: "De la publication du rappel a l'alerte client \u2014 en moins de 2 heures.",
      mod1HowSub: "Des qu'un rappel est publie par la DGCCRF, KYRA l'identifie, isole le GTIN du produit concerne et interroge l'historique d'achat.",
      mod1S1T: "Detection du rappel", mod1S1D: "Surveillance continue de l'API RappelConso V2 officielle.",
      mod1S2T: "Identification des clients", mod1S2D: "Croisement du GTIN avec l'historique d'achat.",
      mod1S3T: "Alerte personnalisee", mod1S3D: "Email et SMS nominatifs envoyes automatiquement.",
      mod1S4T: "Rapport de conformite", mod1S4D: "Preuve d'envoi horodatee, PDF pret pour la DGCCRF.",
      whyTag: "Pourquoi c'est urgent", whyTitle: "Le cout humain et legal de l'inaction.",
      whySub: "Les scandales Panzani, Kinder, Lactalis, Buitoni ont mis en lumiere ce que coute l'absence de notification directe.",
      why1: "Obligation legale renforcee en 2023", why1D: "Les distributeurs ont l'obligation d'identifier et de notifier les consommateurs.",
      why2: "Jusqu'a 75 000 EUR d'amende", why2D: "Par infraction non traitee, prononcee par la DGCCRF.",
      why3: "3 200+ rappels publies par an", why3D: "En France, toutes categories confondues.",
      mod2Label: "Module 02", mod2Title: "Notifications DLC.",
      mod2Sub2: "Reduire le gaspillage a la source.",
      mod2Sub: "53% du gaspillage alimentaire vient des menages. La principale cause : l'oubli. La donnee pour eviter ca est dans vos systemes.",
      mod2HowTag: "Comment ca fonctionne", mod2HowTitle: "La DLC activee comme levier d'engagement client.",
      mod2S1T: "Lecture des DLC", mod2S1D: "Date limite exprimee (frais) ou estimee par categorie.",
      mod2S2T: "Croisement avec les achats", mod2S2D: "Chaque produit achete est associe a sa DLC.",
      mod2S3T: "Notification preventive J-2 / J-1", mod2S3D: "Rappel envoye 48h ou 24h avant la date limite.",
      mod2S4T: "Mesure de l'impact", mod2S4D: "Estimation du gaspillage evite, visible dans le dashboard.",
      mod2LawTag: "Le contexte reglementaire", mod2LawTitle: "Loi AGEC : une obligation a horizon 2030.",
      mod2L1: "-50% de gaspillage d'ici 2025", mod2L1D: "Objectif legal pour la distribution et la restauration.",
      mod2L2: "-50% pour toute la chaine d'ici 2030", mod2L2D: "Objectif elargi a l'ensemble de la chaine alimentaire.",
      mod2L3: "Les menages = 53% du probleme", mod2L3D: "Agir sans toucher les menages, c'est ignorer la moitie de l'enjeu.",
      intLabel: "Integration", intTitle: "Connexion aux systemes existants.",
      intSub: "KYRA s'integre aux infrastructures en place. Pas de refonte, pas de migration.",
      int1Title: "API REST", int1Desc: "Envoi des donnees d'achat en temps reel via endpoint securise.",
      int2Title: "Batch CSV / SFTP", int2Desc: "Export quotidien ou hebdomadaire des lignes de ticket.",
      int3Title: "Connecteur CRM / ERP", int3Desc: "Integration native avec Comarch, SAP, Salesforce.",
      ctaLabel: "Passons a l'action", ctaTitle: "Une demonstration sur vos donnees.",
      ctaSub: "Nous simulons un rappel produit en direct sur un historique d'achat reel. 30 minutes suffisent.",
      ctaBtn: "Prendre rendez-vous",
    },
    engagements: {
      kw1: "Anti-gaspillage", kw2: "Securite alimentaire", kw3: "Transparence",
      h1_1: "Ce que KYRA", h1_2: "defend.",
      sub: "Trois engagements non negociables. Ils precedent toute decision produit, toute relation commerciale, toute ligne de code.",
      p1Tag: "Anti-gaspillage",
      p1Title: "Reduire le gaspillage alimentaire des menages \u2014 mesurer chaque progres.",
      p1T1: "L'Europe gaspille 59 millions de tonnes de nourriture par an. Les menages en sont responsables a 53%. Ce n'est pas une fatalite : c'est un manque d'information au bon moment. KYRA fournit cette information.",
      p1T2: "Chaque notification DLC envoyee est un produit potentiellement sauve. Nous mesurons ce resultat \u2014 en nombre d'alertes envoyees, en kilogrammes de gaspillage estime evite \u2014 et nous le rendons visible.",
      p2Tag: "Securite alimentaire",
      p2Title: "Aucun consommateur ne doit ignorer qu'un produit dans son frigo a ete rappele.",
      p2T1: "Les scandales Panzani, Kinder, Lactalis, Buitoni ont montre ce que coute l'absence d'information directe : hospitalisations, deces, procedures judiciaires. La donnee pour eviter ca existe. Elle n'est pas activee.",
      p2T2: "KYRA ferme cette breche. La securite alimentaire n'est pas un argument commercial \u2014 c'est un enjeu de sante publique. Nous le traitons comme tel.",
      p3Tag: "Transparence",
      p3Title: "Nous ne vendons pas de donnees. Nous les activons au service du consommateur.",
      p3T1: "La donnee d'achat appartient aux consommateurs et aux enseignes. KYRA l'utilise pour envoyer des alertes utiles \u2014 jamais pour la monetiser, la revendre ou la croiser avec des fins publicitaires.",
      p3T2: "Chaque alerte envoyee est tracable, datee et prouvable. Pour le retailer qui veut demontrer sa conformite. Pour le consommateur qui veut comprendre. Pour le regulateur qui controle.",
      valLabel: "En pratique", valTitle: "Ces engagements se traduisent en actes.",
      v1: "Donnees hebergees en France", v1D: "Infrastructure 100% francaise. Aucun transfert de donnees hors UE.",
      v2: "RGPD by design", v2D: "Pseudonymisation des identifiants clients des l'ingestion. DPA disponible.",
      v3: "Zero revente de donnees", v3D: "Les donnees d'achat ne sont utilisees qu'a des fins d'alerte. Jamais monetisees.",
      v4: "Impact mesure", v4D: "Rapport mensuel sur le gaspillage evite et les alertes rappels traitees.",
      v5: "Audit trail complet", v5D: "Chaque alerte envoyee est enregistree avec horodatage. PDF de conformite disponible.",
      v6: "Open a l'audit", v6D: "KYRA accepte les audits de securite et de conformite des enseignes partenaires.",
      ctaTitle: "Parlons de vos enjeux.",
      ctaSub: "Ces engagements ne sont pas des arguments de vente. Ce sont les conditions de notre partenariat.",
      ctaBtn: "Prendre rendez-vous",
    },
    contact: {
      kw1: "Anti-gaspillage", kw2: "Securite alimentaire",
      h2_1: "Vous avez les donnees.", h2_2: "Parlons de la suite.",
      sub: "KYRA est en phase de deploiement. Nous rencontrons actuellement des enseignes, des distributeurs et des partenaires qui partagent ces enjeux. Un echange de 30 minutes suffit pour evaluer si nous pouvons travailler ensemble.",
      emailLabel: "Email", societeLabel: "Societe",
      youAre: "Vous etes",
      prof1: "Retailer ou enseigne GMS \u2014 vous gerez un programme de fidelite",
      prof2: "Distributeur ou centrale d'achat \u2014 vous pilotez la supply chain",
      prof3: "Investisseur ou partenaire strategique \u2014 vous cherchez a soutenir un impact reel",
      formTitle: "Prendre rendez-vous",
      formSub: "Reponse sous 24h ouvrees.",
      labelPrenom: "Prenom", labelNom: "Nom", labelEmail: "Email professionnel", labelSociete: "Societe",
      labelProfil: "Vous etes", labelSujet: "Sujet", labelMessage: "Message",
      phPrenom: "Jean", phNom: "Dupont", phEmail: "j.dupont@enseigne.fr", phSociete: "Nom de votre enseigne ou groupe",
      phProfil: "Selectionner votre profil", phSujet: "Selectionner un sujet",
      phMessage: "Decrivez votre contexte, vos enjeux...",
      profOpt1: "Retailer / Enseigne GMS", profOpt2: "Distributeur / Centrale d'achat", profOpt3: "Investisseur / VC", profOpt4: "Partenaire strategique", profOpt5: "Autre",
      sujOpt1: "Demander une demonstration", sujOpt2: "Module Rappels produits", sujOpt3: "Module Notifications DLC", sujOpt4: "Partenariat / Investissement", sujOpt5: "Autre demande",
      submitBtn: "Envoyer",
      submitting: "Envoi en cours...",
      privacy: "Vos donnees ne sont utilisees qu'a des fins de reponse a votre demande.",
      privacyLink: "Voir nos engagements",
      successTitle: "Message envoye.",
      successText: "Nous vous repondrons sous 24h ouvrees.",
      successLink: "notre solution en detail",
      errRequired: "Veuillez remplir tous les champs obligatoires.",
      errSend: "Erreur lors de l'envoi. Reessayez.",
      okSend: "Message envoye avec succes !",
    },
    casReels: {
      kw1: "Securite alimentaire", kw2: "Cas reels",
      h1_1: "Quand l'absence de notification", h1_2: "coute des vies.",
      sub: "Chaque grande crise alimentaire partage le meme defaut structurel : les distributeurs peuvent identifier le produit, mais pas les foyers encore exposes. KYRA resout exactement ce vide.",
      badge1: "6 crises majeures analysees",
      badge2: "Des millions de consommateurs non alertes",
      structTitle: "Les retailers savent quel produit est contamine.",
      structTitle2: "Mais ils ne savent pas qui l'a encore chez soi.",
      structSub: "C'est cette lacune que KYRA comble \u2014 en croisant les donnees d'achat avec les rappels officiels pour generer des alertes nominatives, tracables et immediates.",
      structLabel: "Le probleme structurel",
      crisesLabel: "Les crises",
      crisesTitle: "6 scandales. Un meme echec.",
      impactLabel: "Impact",
      problemLabel: "Probleme cle",
      consequenceLabel: "Consequence",
      kyraLabel: "Avec KYRA",
      conclusionLabel: "La reponse",
      conclusionTitle1: "Ces crises ne sont pas des exceptions.",
      conclusionTitle2: "C'est le systeme actuel.",
      conclusionSub: "Tant que les rappels reposent sur l'affichage en rayon et les communiques de presse, les consommateurs resteront exposes. KYRA change la donne en activant la donnee d'achat \u2014 le seul lien direct entre le produit rappele et le foyer concerne.",
      ctaBtn1: "Discutons de votre enseigne",
      ctaBtn2: "Voir la solution technique",
    },
    login: {
      subtitle: "Plateforme de securite alimentaire & anti-gaspillage",
      tabLogin: "Connexion",
      tabRegister: "Inscription",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      phEmail: "admin@kyra.fr",
      phPassword: "Votre mot de passe",
      phName: "Jean Dupont",
      phEmailReg: "j.dupont@enseigne.fr",
      phPasswordReg: "Mot de passe securise",
      passwordHint: "Mot de passe (min 6 caracteres)",
      loginBtn: "Se connecter",
      loginBtnLoading: "Connexion...",
      registerBtn: "Creer un compte",
      registerBtnLoading: "Inscription...",
      backToSite: "Retour au site",
    },
    dashboard: {
      overview: "Vue d'ensemble",
      subtitle: "Tableau de bord KYRA \u2014 donnees en temps reel",
      recalls: "Rappels produits",
      dlcNotifs: "Notifications DLC",
      alertsSent: "Alertes envoyees",
      compliance: "Conformite",
      purchases: "Achats",
      seedDemo: "Seed demo",
      pollRappel: "Polling RappelConso",
      recallsStored: "Rappels stockes",
      purchasesIndexed: "Achats indexes",
      alertsCount: "Alertes envoyees",
      dlcCount: "Notifications DLC",
      byType: "Alertes par type",
      quickActions: "Actions rapides",
      seeRecalls: "Voir les rappels produits",
      generateDlc: "Generer les notifications DLC",
      alertsHistory: "Historique des alertes",
      lastRecalls: "Derniers rappels stockes",
      seeAll: "Tout voir",
      clients: "clients",
      logout: "Deconnexion",
      loading: "Chargement...",
      downloadPdf: "Telecharger PDF DGCCRF",
      generating: "Generation...",
      liveReport: "Rapport en direct",
      recallsPageTitle: "Rappels produits",
      recallsPageSub: "Surveillance de l'API RappelConso V2 \u2014 rappels alimentaires",
      pollMatch: "Poll & Match",
      polling: "Polling...",
      tabLive: "API en direct",
      tabStored: "Stockes",
      date: "Date", product: "Produit", brand: "Marque", reason: "Motif", risks: "Risques", gtin: "GTIN", sheet: "Fiche",
      noRecalls: "Aucun rappel disponible",
      noRecallsStored: "Aucun rappel stocke. Lancez un poll pour importer.",
      matchedCustomers: "Clients touches", alertsSentCol: "Alertes envoyees", status: "Statut",
      dlcPageTitle: "Notifications DLC",
      dlcPageSub: "Produits proches de leur date limite de consommation",
      generateNotifs: "Generer notifications",
      urgency: "Urgence", client: "Client", dlcDate: "DLC", daysLeft: "Jours restants",
      today: "Aujourd'hui",
      noDlc: "Aucune notification DLC",
      noDlcSub: "Ajoutez des achats avec DLC puis generez les notifications.",
      alertsPageTitle: "Alertes envoyees",
      alertsPageSub: "Historique de toutes les alertes envoyees aux consommateurs (MOCK)",
      total: "total",
      tabAll: "Toutes", tabRecall: "Rappels", tabDlc: "DLC",
      type: "Type", details: "Details", channel: "Canal", sentDate: "Date envoi",
      noAlerts: "Aucune alerte",
      complianceTitle: "Conformite",
      complianceSub: "Rapports et metriques de conformite DGCCRF & Loi AGEC",
      recallsProcessed: "Rappels traites",
      recallsProcessedSub: "Produits surveilles et alertes emises",
      wasteAvoided: "Gaspillage evite (est.)",
      wasteAvoidedSub: "Base : 350g evites par notification DLC",
      consumersAlerted: "Consommateurs alertes",
      consumersAlertedSub: "Alertes rappels + notifications DLC",
      volumesByCategory: "Volumes par categorie",
      alertDistribution: "Repartition des alertes",
      noAlertData: "Pas encore de donnees d'alertes",
      purchasesTitle: "Achats indexes",
      purchasesSub: "Historique des achats clients ingeres via l'API",
      addPurchase: "Ajouter un achat",
      addPurchaseTitle: "Ajouter un achat",
      clientId: "Client ID", emailClient: "Email client", productName: "Nom produit",
      purchaseDate: "Date achat", category: "Categorie",
      noPurchases: "Aucun achat. Utilisez le seed ou ajoutez manuellement.",
      add: "Ajouter",
      purchaseAdded: "Achat ajoute",
      purchaseError: "Erreur lors de l'ajout",
    },
  },
  en: {
    nav: {
      solution: "Solution",
      casReels: "Case studies",
      engagements: "Commitments",
      dashboard: "Dashboard",
      connexion: "Login",
      contact: "Contact",
    },
    footer: {
      tagline: "Anti-waste \u00b7 Food safety \u00b7 Transparency",
    },
    home: {
      heroTag1: "Plug & play", heroTag2: "Zero friction", heroTag3: "Data activation", heroTag4: "New revenue",
      h1_1: "Activate your dormant data.", h1_2: "Create value.", h1_3: "No friction.",
      heroP: "KYRA transforms data already present in your systems \u2014 expiry dates, product recalls, purchase histories \u2014 into levers for economic performance, food safety, and waste reduction.",
      heroPills: ["Plug & play", "Zero user friction", "No operational complexity", "Existing data activation"],
      ctaContact: "Request a demo",
      ctaSolution: "Discover the solution",
      heroKpi1V: "0", heroKpi1L: "added friction", heroKpi2V: "100%", heroKpi2L: "existing data", heroKpi3V: "2h", heroKpi3L: "recall alert delay", heroKpi4V: "D-2", heroKpi4L: "expiry notification",

      probLabel: "The problem",
      probTitle: "The data exists. It's not activated.",
      probSub: "Retailers and brands face simultaneous pressures: regulatory compliance, product recalls, health risks, reputational risks, 2030 anti-waste targets. The data to respond is there. But it remains siloed, not exploited in real time, disconnected from business decisions.",
      probCards: [
        { title: "Regulatory pressure", desc: "Growing obligations on food safety and recalls. Up to \u20ac75,000 fine per violation." },
        { title: "Recall exposure", desc: "Recalled products already in households. No direct link between the product and the exposed household." },
        { title: "Reputational risk", desc: "Every poorly managed crisis destroys trust. Kinder, Lactalis, Buitoni: the precedents are clear." },
        { title: "Food waste", desc: "131 kg wasted per person per year in Europe. Households account for 53% of losses." }
      ],
      probInsight: "The real problem isn't the absence of data. It's that data is poorly exploited, siloed, and not activated in real time.",
      probRegTitle: "Shift the regulatory risk.",
      probRegText: "KYRA shifts the regulatory friction point to an external agent. This directly reduces the retailer's operational and legal exposure.",

      solLabel: "The KYRA solution",
      solTitle: "Activate what exists. Without adding anything.",
      solSub: "KYRA activates data already present but unexploited. Expiry dates, recalls, purchase histories: everything is transformed into actionable decisions, with zero additional operational complexity.",
      solPills: ["Plug & play", "Integrates with existing systems", "Zero friction", "No added complexity"],
      solF1T: "Activates expiry dates & recalls", solF1D: "Real-time exploitation of use-by dates and official product recalls.",
      solF2T: "Reduces losses", solF2D: "Stock optimization and reduced product destruction through data activation.",
      solF3T: "Secures the food chain", solF3D: "Proactive recall management with direct notification to affected consumers.",
      solF4T: "Generates new revenue", solF4D: "Dormant assets transformed into economic performance levers for retailers and brands.",
      solRegTitle: "Regulatory orchestration layer",
      solRegText: "KYRA acts as a buffer layer between the retailer and compliance obligations. Regulatory risk is shifted to an external agent, significantly reducing the retailer's exposure.",
      solNoComplex: "KYRA doesn't add operational complexity: it activates what already exists, but which is neither exploited in real time, nor integrated into business decisions.",

      fsLabel: "Food safety",
      fsTitle: "Protect your customers. Protect your brand.",
      fsSub: "KYRA transforms product recall management from a suffered risk into a controlled competitive advantage.",
      fsItems: [
        { title: "Proactive recall management", desc: "Automatic detection, cross-referencing with purchases, immediate notification to affected consumers." },
        { title: "Reduced health risks", desc: "No consumer is left unaware that a recalled product is in their fridge." },
        { title: "Brand protection", desc: "React in 2 hours instead of 2 weeks. Total control of crisis communication." },
        { title: "Guaranteed compliance", desc: "DGCCRF compliance report auto-generated. Timestamped, traceable proof of delivery." }
      ],
      fsKpi1V: "3,200+", fsKpi1L: "recalls/year in France", fsKpi2V: "< 2h", fsKpi2L: "alert delay", fsKpi3V: "100%", fsKpi3L: "traceability",

      fwLabel: "Anti-waste",
      fwTitle: "Turn losses into value.",
      fwSub: "KYRA leverages use-by dates to reduce losses, optimize stock, and contribute to 2030 zero waste targets.",
      fwItems: [
        { title: "Smart expiry date exploitation", desc: "Every purchased product is tracked. Consumers are warned before products expire." },
        { title: "Loss reduction", desc: "Fewer products thrown away = better margin. Direct stock yield optimization." },
        { title: "Economic value creation", desc: "Dormant assets transformed into revenue levers for retailers and brands." },
        { title: "Zero waste 2030 target", desc: "AGEC Law: -50% waste by 2030. KYRA provides the tool to get there." }
      ],
      fwKpi1V: "59 M", fwKpi1L: "tonnes of waste/year in Europe", fwKpi2V: "131 kg", fwKpi2L: "wasted/person/year", fwKpi3V: "-50%", fwKpi3L: "2030 target",

      ctaLabel: "Contact",
      ctaTitle: "Let's talk.",
      ctaSub: "You're a retailer, distributor, or investor. Discover how KYRA activates your dormant data.",
      ctaBtn1: "Request a demo",
      ctaBtn2: "See the solution",
    },
    solutions: {
      kw1: "Food safety", kw2: "Anti-waste", kw3: "Two modules",
      h1_1: "The data you already have.", h1_2: "Activated for your customers.",
      sub: "KYRA connects to retailers' existing systems. No rebuild. No heavy infrastructure. Two complementary modules, one principle: the right information, at the right time, to the right person.",
      ctaDemo: "Request a demo",
      archLabel: "Architecture", archTitle: "How KYRA works.",
      archSub: "Purchase data comes in. Recalls and expiry dates feed the engine. Alerts go out \u2014 personalized, automatic, traceable.",
      mod1Label: "Module 01", mod1Title: "Product recalls.",
      mod1Sub2: "No consumer left uninformed.",
      mod1Sub: "3,200+ recalls are published every year in France. Most consumers who purchased these products never find out. KYRA closes that gap.",
      mod1HowTag: "How it works",
      mod1HowTitle: "From recall publication to customer alert \u2014 in under 2 hours.",
      mod1HowSub: "As soon as a recall is published by DGCCRF, KYRA identifies it, isolates the product GTIN and queries the purchase history.",
      mod1S1T: "Recall detection", mod1S1D: "Continuous monitoring of the official RappelConso V2 API.",
      mod1S2T: "Customer identification", mod1S2D: "GTIN cross-referencing with purchase history.",
      mod1S3T: "Personalized alert", mod1S3D: "Targeted email and SMS sent automatically.",
      mod1S4T: "Compliance report", mod1S4D: "Timestamped proof of delivery, PDF ready for DGCCRF.",
      whyTag: "Why it's urgent", whyTitle: "The human and legal cost of inaction.",
      whySub: "The Panzani, Kinder, Lactalis, Buitoni scandals exposed what the absence of direct notification costs.",
      why1: "Strengthened legal obligation in 2023", why1D: "Retailers must identify and notify affected consumers.",
      why2: "Up to \u20ac75,000 fine", why2D: "Per unresolved violation, imposed by DGCCRF.",
      why3: "3,200+ recalls published per year", why3D: "In France, all categories combined.",
      mod2Label: "Module 02", mod2Title: "Expiry notifications.",
      mod2Sub2: "Reduce waste at the source.",
      mod2Sub: "53% of food waste comes from households. The main cause: forgetting. The data to prevent this is in your systems.",
      mod2HowTag: "How it works", mod2HowTitle: "Use-by dates as a customer engagement lever.",
      mod2S1T: "Reading use-by dates", mod2S1D: "Expressed (fresh) or estimated date by category.",
      mod2S2T: "Cross-referencing with purchases", mod2S2D: "Each purchased product is linked to its use-by date.",
      mod2S3T: "Preventive notification D-2 / D-1", mod2S3D: "Reminder sent 48h or 24h before the date.",
      mod2S4T: "Impact measurement", mod2S4D: "Estimated waste avoided, visible in the dashboard.",
      mod2LawTag: "Regulatory context", mod2LawTitle: "AGEC Law: a 2030 deadline.",
      mod2L1: "-50% waste by 2025", mod2L1D: "Legal target for distribution and catering.",
      mod2L2: "-50% for the entire chain by 2030", mod2L2D: "Extended target across the entire food chain.",
      mod2L3: "Households = 53% of the problem", mod2L3D: "Acting without reaching households means ignoring half the issue.",
      intLabel: "Integration", intTitle: "Connecting to existing systems.",
      intSub: "KYRA integrates with existing infrastructure. No rebuild, no migration.",
      int1Title: "REST API", int1Desc: "Real-time purchase data via secure endpoint.",
      int2Title: "Batch CSV / SFTP", int2Desc: "Daily or weekly export of receipt lines.",
      int3Title: "CRM / ERP Connector", int3Desc: "Native integration with Comarch, SAP, Salesforce.",
      ctaLabel: "Let's act", ctaTitle: "A demo on your data.",
      ctaSub: "We simulate a product recall live on a real purchase history. 30 minutes is all it takes.",
      ctaBtn: "Book a meeting",
    },
    engagements: {
      kw1: "Anti-waste", kw2: "Food safety", kw3: "Transparency",
      h1_1: "What KYRA", h1_2: "stands for.",
      sub: "Three non-negotiable commitments. They precede every product decision, every business relationship, every line of code.",
      p1Tag: "Anti-waste",
      p1Title: "Reduce household food waste \u2014 measure every step forward.",
      p1T1: "Europe wastes 59 million tonnes of food per year. Households account for 53%. This isn't inevitable: it's a lack of information at the right time. KYRA provides that information.",
      p1T2: "Every expiry notification sent is a product potentially saved. We measure this \u2014 in alerts sent, in estimated kilograms of waste avoided \u2014 and make it visible.",
      p2Tag: "Food safety",
      p2Title: "No consumer should be unaware that a recalled product is in their fridge.",
      p2T1: "The Panzani, Kinder, Lactalis, Buitoni scandals showed the cost of missing direct information: hospitalizations, deaths, lawsuits. The data to prevent this exists. It's not activated.",
      p2T2: "KYRA closes this gap. Food safety is not a sales pitch \u2014 it's a public health issue. We treat it as such.",
      p3Tag: "Transparency",
      p3Title: "We don't sell data. We activate it for the consumer.",
      p3T1: "Purchase data belongs to consumers and retailers. KYRA uses it to send useful alerts \u2014 never to monetize, resell, or cross-reference for advertising.",
      p3T2: "Every alert sent is traceable, dated, and provable. For the retailer proving compliance. For the consumer understanding why they were contacted. For the regulator auditing.",
      valLabel: "In practice", valTitle: "These commitments translate into actions.",
      v1: "Data hosted in France", v1D: "100% French infrastructure. No data transfers outside the EU.",
      v2: "GDPR by design", v2D: "Customer identifiers pseudonymized at ingestion. DPA available.",
      v3: "Zero data resale", v3D: "Purchase data is only used for alerts. Never monetized.",
      v4: "Measured impact", v4D: "Monthly report on waste avoided and recall alerts processed.",
      v5: "Complete audit trail", v5D: "Every alert is logged with timestamps. Compliance PDF available.",
      v6: "Open to audit", v6D: "KYRA accepts security and compliance audits from partner retailers.",
      ctaTitle: "Let's discuss your challenges.",
      ctaSub: "These commitments are not sales arguments. They are the conditions of our partnership.",
      ctaBtn: "Book a meeting",
    },
    contact: {
      kw1: "Anti-waste", kw2: "Food safety",
      h2_1: "You have the data.", h2_2: "Let's talk next steps.",
      sub: "KYRA is in deployment phase. We're currently meeting with retailers, distributors, and partners who share these challenges. A 30-minute exchange is enough to evaluate if we can work together.",
      emailLabel: "Email", societeLabel: "Company",
      youAre: "You are",
      prof1: "Retailer or supermarket chain \u2014 you manage a loyalty program",
      prof2: "Distributor or buying group \u2014 you manage the supply chain",
      prof3: "Investor or strategic partner \u2014 you seek to support real impact",
      formTitle: "Book a meeting",
      formSub: "Response within 24 business hours.",
      labelPrenom: "First name", labelNom: "Last name", labelEmail: "Professional email", labelSociete: "Company",
      labelProfil: "You are", labelSujet: "Subject", labelMessage: "Message",
      phPrenom: "John", phNom: "Smith", phEmail: "j.smith@retailer.com", phSociete: "Your company or group name",
      phProfil: "Select your profile", phSujet: "Select a subject",
      phMessage: "Describe your context, challenges...",
      profOpt1: "Retailer / Supermarket chain", profOpt2: "Distributor / Buying group", profOpt3: "Investor / VC", profOpt4: "Strategic partner", profOpt5: "Other",
      sujOpt1: "Request a demo", sujOpt2: "Product recalls module", sujOpt3: "Expiry notifications module", sujOpt4: "Partnership / Investment", sujOpt5: "Other",
      submitBtn: "Send",
      submitting: "Sending...",
      privacy: "Your data is only used to respond to your request.",
      privacyLink: "See our commitments",
      successTitle: "Message sent.",
      successText: "We'll respond within 24 business hours.",
      successLink: "our solution in detail",
      errRequired: "Please fill in all required fields.",
      errSend: "Error sending. Please try again.",
      okSend: "Message sent successfully!",
    },
    casReels: {
      kw1: "Food safety", kw2: "Case studies",
      h1_1: "When the absence of notification", h1_2: "costs lives.",
      sub: "Every major food crisis shares the same structural flaw: distributors can identify the product, but not the households still exposed. KYRA solves that exact gap.",
      badge1: "6 major crises analyzed",
      badge2: "Millions of consumers left unalerted",
      structTitle: "Retailers know which product is contaminated.",
      structTitle2: "But they don't know who still has it at home.",
      structSub: "KYRA bridges this gap \u2014 by cross-referencing purchase data with official recalls to generate targeted, traceable, and immediate alerts.",
      structLabel: "The structural problem",
      crisesLabel: "The crises",
      crisesTitle: "6 scandals. The same failure.",
      impactLabel: "Impact",
      problemLabel: "Key problem",
      consequenceLabel: "Consequence",
      kyraLabel: "With KYRA",
      conclusionLabel: "The answer",
      conclusionTitle1: "These crises are not exceptions.",
      conclusionTitle2: "This is the current system.",
      conclusionSub: "As long as recalls rely on in-store displays and press releases, consumers will remain exposed. KYRA changes the game by activating purchase data \u2014 the only direct link between the recalled product and the affected household.",
      ctaBtn1: "Let's discuss your chain",
      ctaBtn2: "See the technical solution",
    },
    login: {
      subtitle: "Food safety & anti-waste platform",
      tabLogin: "Login",
      tabRegister: "Register",
      email: "Email",
      password: "Password",
      name: "Full name",
      phEmail: "admin@kyra.fr",
      phPassword: "Your password",
      phName: "John Smith",
      phEmailReg: "j.smith@retailer.com",
      phPasswordReg: "Secure password",
      passwordHint: "Password (min 6 characters)",
      loginBtn: "Log in",
      loginBtnLoading: "Logging in...",
      registerBtn: "Create account",
      registerBtnLoading: "Registering...",
      backToSite: "Back to site",
    },
    dashboard: {
      overview: "Overview",
      subtitle: "KYRA dashboard \u2014 real-time data",
      recalls: "Product recalls",
      dlcNotifs: "Expiry notifications",
      alertsSent: "Alerts sent",
      compliance: "Compliance",
      purchases: "Purchases",
      seedDemo: "Seed demo",
      pollRappel: "Poll RappelConso",
      recallsStored: "Stored recalls",
      purchasesIndexed: "Indexed purchases",
      alertsCount: "Alerts sent",
      dlcCount: "Expiry notifications",
      byType: "Alerts by type",
      quickActions: "Quick actions",
      seeRecalls: "View product recalls",
      generateDlc: "Generate expiry notifications",
      alertsHistory: "Alerts history",
      lastRecalls: "Latest stored recalls",
      seeAll: "View all",
      clients: "customers",
      logout: "Log out",
      loading: "Loading...",
      downloadPdf: "Download DGCCRF PDF",
      generating: "Generating...",
      liveReport: "Live report",
      recallsPageTitle: "Product recalls",
      recallsPageSub: "Monitoring RappelConso V2 API \u2014 food recalls",
      pollMatch: "Poll & Match",
      polling: "Polling...",
      tabLive: "Live API",
      tabStored: "Stored",
      date: "Date", product: "Product", brand: "Brand", reason: "Reason", risks: "Risks", gtin: "GTIN", sheet: "Sheet",
      noRecalls: "No recalls available",
      noRecallsStored: "No stored recalls. Run a poll to import.",
      matchedCustomers: "Matched customers", alertsSentCol: "Alerts sent", status: "Status",
      dlcPageTitle: "Expiry notifications",
      dlcPageSub: "Products approaching their use-by date",
      generateNotifs: "Generate notifications",
      urgency: "Urgency", client: "Client", dlcDate: "Use-by", daysLeft: "Days left",
      today: "Today",
      noDlc: "No expiry notifications",
      noDlcSub: "Add purchases with expiry dates then generate notifications.",
      alertsPageTitle: "Alerts sent",
      alertsPageSub: "History of all alerts sent to consumers (MOCK)",
      total: "total",
      tabAll: "All", tabRecall: "Recalls", tabDlc: "Expiry",
      type: "Type", details: "Details", channel: "Channel", sentDate: "Sent date",
      noAlerts: "No alerts",
      complianceTitle: "Compliance",
      complianceSub: "Compliance reports and metrics DGCCRF & AGEC Law",
      recallsProcessed: "Recalls processed",
      recallsProcessedSub: "Products monitored and alerts issued",
      wasteAvoided: "Waste avoided (est.)",
      wasteAvoidedSub: "Based on 350g avoided per expiry notification",
      consumersAlerted: "Consumers alerted",
      consumersAlertedSub: "Recall alerts + expiry notifications",
      volumesByCategory: "Volumes by category",
      alertDistribution: "Alert distribution",
      noAlertData: "No alert data yet",
      purchasesTitle: "Indexed purchases",
      purchasesSub: "Customer purchase history ingested via API",
      addPurchase: "Add purchase",
      addPurchaseTitle: "Add a purchase",
      clientId: "Client ID", emailClient: "Client email", productName: "Product name",
      purchaseDate: "Purchase date", category: "Category",
      noPurchases: "No purchases. Use seed or add manually.",
      add: "Add",
      purchaseAdded: "Purchase added",
      purchaseError: "Error adding purchase",
    },
  },
};
